import { render, staticRenderFns } from "./approveFooter.vue?vue&type=template&id=f7a34a06&scoped=true"
import script from "./approveFooter.vue?vue&type=script&lang=js"
export * from "./approveFooter.vue?vue&type=script&lang=js"
import style0 from "./approveFooter.vue?vue&type=style&index=0&id=f7a34a06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a34a06",
  null
  
)

export default component.exports